import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padded?: boolean;
  raised?: boolean;
}

// The one card/panel surface every screen composes from — matches the
// production app's `.panel`/`.metric-card` treatment (dark charcoal card,
// hairline border, soft drop shadow) instead of a generic white box.
export function Card({ children, className = '', padded = true, raised = false }: CardProps) {
  return (
    <div
      className={`rounded-card border border-ink-border ${raised ? 'bg-panel-gradient' : 'bg-ink-surface'} shadow-card ${padded ? 'p-4 sm:p-5' : ''} ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
  eyebrow,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  eyebrow?: ReactNode;
}) {
  return (
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="min-w-0">
        {eyebrow && <p className="mb-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold-500">{eyebrow}</p>}
        <h2 className="text-sm font-bold text-white sm:text-base">{title}</h2>
        {subtitle && <p className="mt-0.5 text-xs text-slate-400">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
